module.exports = __webpack_public_path__ + "img/tech17mb.43832e93.png";